import React from "react";
import Community from "../../../assets/images/Community.svg"; // Fallback image
import { Link, useNavigate } from "react-router-dom";

const HowToConvene: React.FC = () => {
  const steps = [
    {
      num: "1",
      title: "Reach Out",
      desc: "Call or email us as an expression of interest to take part in the CBR Program.",
    },
    {
      num: "2",
      title: "Organize the class",
      desc: "Set the venue and time for the sessions and invite your community.",
    },
    {
      num: "3",
      title: "Launch the Program",
      desc: "We will avail a training team to run the classs.",
    },


  ];

  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gray-50/30">
      <div className="container mx-auto px-4 lg:px-4">
        <div>
          <p className="text-navYellow font-medium text-xl tracking-wider mb-3">Bring CBR To Your Community</p>
          <h2 className="text-3xl lg:text-4xl font-semibold text-darkBlue mb-4">
            How to Convene a CBR Class
          </h2>
          <p className="text-gray-600 mb-10 text-lg leading-relaxed max-w-3xl">
            Interested in bringing the CBR Program to your church, school, or community? We'd love to partner with you in developing a culture of consistent Bible reading.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-16">
          {/* Left Side - Text & Steps */}
          <div className="w-full lg:w-1/2">

            <div className="space-y-8 mb-10 relative">
              {/* Vertical connecting line */}
              <div className="absolute left-[19px] top-4 bottom-8 w-0.5 bg-[#7590AB]/20 z-0 hidden sm:block"></div>

              {steps.map((step, idx) => (
                <div key={idx} className="flex gap-6 relative z-10">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#7590AB] text-white flex items-center justify-center font-bold text-lg shadow-md">
                    {step.num}
                  </div>
                  <div className="pb-1">
                    <h4 className="font-semibold text-xl text-darkBlue mb-2">{step.title}</h4>
                    <p className="text-gray-500 max-w-md text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="bg-[#BBD0F7] text-[#1D326A] font-medium py-3 px-10 rounded-full hover:bg-blue-200 transition-colors shadow-sm " onClick={() => navigate("/contacts")} >
              Contact Us
            </button>
          </div>

          {/* Right Side - Image */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <img
              src={Community}
              alt="Convene a Course"
              className="rounded-2xl h-[320px] md:h-[420px] lg:h-[500px]"
            />

          </div>

        </div>
      </div>
    </section >
  );
};

export default HowToConvene;
